module.exports = __webpack_public_path__ + "images/interview-Humna-2.svg";